export { default as CustomerLayout } from './CustomerLayout';
